import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "select-categories" }
const _hoisted_2 = { class: "mas ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_SelectCategoriesSelected = _resolveComponent("SelectCategoriesSelected")!
  const _component_ProductCategoriesTree = _resolveComponent("ProductCategoriesTree")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal_button, {
      class: _normalizeClass(["", _ctx.btnClass]),
      "modal-id": _ctx.selectCategoriesModalId
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('searchCategory')), 1),
        _createElementVNode("i", _hoisted_2, _toDisplayString(_ctx.btnIcon), 1)
      ]),
      _: 1
    }, 8, ["class", "modal-id"]),
    _createVNode(_component_SelectCategoriesSelected, {
      "selected-product-categories": _ctx.formattedSelectedProductCategories,
      "catalog-customer-code": _ctx.catalogCustomerCode,
      id: "overview",
      onRemoveCategory: _ctx.removeCategory
    }, null, 8, ["selected-product-categories", "catalog-customer-code", "onRemoveCategory"]),
    _createVNode(_component_base_modal, {
      "modal-id": _ctx.selectCategoriesModalId,
      title: _ctx.$t('categories'),
      "min-z-index": 2010,
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectCategoriesSelected, {
          "selected-product-categories": _ctx.formattedSelectedProductCategories,
          "catalog-customer-code": _ctx.catalogCustomerCode,
          id: "modal",
          class: "mb-4",
          onRemoveCategory: _ctx.removeCategory
        }, null, 8, ["selected-product-categories", "catalog-customer-code", "onRemoveCategory"]),
        (_ctx.filteredCategoriesTree)
          ? (_openBlock(), _createBlock(_component_ProductCategoriesTree, {
              key: 0,
              "categories-tree": _ctx.filteredCategoriesTree,
              onSelectCategory: _ctx.addCategory
            }, null, 8, ["categories-tree", "onSelectCategory"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ]))
}